import { request } from './request'

export interface UploadResponse {
  url: string
}

/**
 * 上传图片
 * @param file 图片文件
 * @returns 上传后的图片相对路径
 */
export const uploadImage = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  return request<UploadResponse, FormData>({
    url: '/upload/image',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 获取图片完整 URL
 * @param path 图片相对路径（如 /images/2026/08/xxx.png）
 * @returns 完整可访问的图片 URL
 */
export const getImageUrl = (path: string): string => {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${import.meta.env.VITE_API_BASE_URL}${path}`
}